import React, { useEffect, useState } from "react";
import { Compliment, Room } from "../../types";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import TestimonialCard from "./TestimonialCard";
import { getRoomCompliments } from "../../services/complimentService";

interface Props {
  room: Room;
}

function RoomTestimonials({ room }: Props) {
  const [testimonials, setTestimonials] = useState<Compliment[]>([]);

  useEffect(() => {
    getRoomCompliments(room._id, true)
      .then((res) => {
        setTestimonials(res?.data || []);
      })
      .catch(() => {});
  }, []);

  const carouselResponsiveConfig = {
    all: {
      breakpoint: { max: 4000, min: 464 },
      items: 1,
      partialVisibilityGutter: 50,
    },
  };

  if (!testimonials?.length) return null;

  return (
    <div className="md:pr-10 pt-1 flex flex-col max-w-md">
      <p className="text-base font-bold pb-2 text-black dark:text-frescoWhite">
        See What Other Are Saying
      </p>
      <p className="text-sm font-normal  text-darkGray whitespace-pre-wrap">
        Read about what others think about this group before you join.
      </p>
      <div className="pt-3 max-w-md">
        <Carousel
          swipeable
          draggable={false}
          arrows
          itemClass="px-1.5"
          renderButtonGroupOutside
          responsive={carouselResponsiveConfig}
          keyBoardControl
          partialVisbile
        >
          {testimonials?.map((item) => (
            <TestimonialCard key={item._id} testimonial={item} />
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export default RoomTestimonials;
